import * as yup from 'yup';

const questionRule = yup
  .string()
  .required('A resposta para essa pergunta é obrigatório');

export const QuestionarioPerfilInvestidorSchema = yup.object({
  questao1: questionRule,
  questao2: questionRule,
  questao3: questionRule,
  questao4: questionRule,
  questao6: questionRule,
  questao7: questionRule,
});

export const QuestionarioPerfilInvestidorValues = {
  questao1: '',
  questao2: '',
  questao3: '',
  questao4: '',
  questao5: '',
  questao5_1: '',
  questao5_2: '',
  questao5_3: '',
  questao5_4: '',
  questao6: '',
  questao7: '',
};
